import { createFileRoute } from "@tanstack/react-router";

import { RecepturaMaterialsPage } from "@/features/receptura/materials-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/receptura/surowce")({
	component: RecepturaMaterialsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.receptura.surowce", location.pathname);
	},
});
